import {Component, computed, inject} from '@angular/core'
import {
  MatButton,
  MatIconButton,
  MatMiniFabButton
} from '@angular/material/button'
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent
} from '@angular/material/dialog'
import {MatIcon} from '@angular/material/icon'
import {MatDivider} from '@angular/material/list'
import {RouterLink} from '@angular/router'
import {
  HOME_PATH,
  PROFILE_PATH,
  PROJECTS_PATH,
  SIGN_PATH
} from '../../general/shared'
import {UserService} from '../../services/user-service'

@Component({
  selector: 'smt-menu',
  imports: [
    MatIcon,
    MatMiniFabButton,
    MatDivider,
    MatDialogContent,
    MatDialogActions,
    MatIconButton,
    MatButton,
    RouterLink,
    MatDialogClose
  ],
  templateUrl: './menu.html',
  styleUrl: './menu.scss',
})
export class Menu {

  public readonly userService = inject(UserService)

  public isAdmin = computed(() => this.userService.user().scopes
    .includes('admin'))
  protected readonly PROFILE_PATH = PROFILE_PATH
  protected readonly HOME_PATH = HOME_PATH
  protected readonly SIGN_PATH = SIGN_PATH
  protected readonly PROJECTS_PATH = PROJECTS_PATH
}
